import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

export interface InvoiceFilterParams {
  hospitalId?: string;
  invoiceStatus?: string[];
  modeOfPayment?: string[];
  modeOfRefund?: string[];
  statusOfBill?: string[];
  canceledBillDetails?: string;
  limit?: number;
  offset?: number;
  search?: string;
  [key: string]: string | string[] | boolean | number | undefined;
}

const getInvoiceApi = createAsyncThunk(
  'getInvoiceApi',
  async (filterParams: InvoiceFilterParams = {}) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const roleRaw = sessionStorage.getItem('role') || localStorage.getItem('role');
      const role = roleRaw === 'Government' ? 'government' : roleRaw;

      const payload = {
        hospitalId: hospitalId || '',
        from: role,
        limit: filterParams.limit || 10,
        offset: filterParams.offset || 0,
        search: filterParams.search || '',
        ...filterParams,
      };

      const response = await fetch(BILLING_ROUTES.INVOICE.get, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(`Failed to fetch Billing Details: ${errorBody}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Invoice API Error:', error);
      return Promise.reject(error);
    }
  }
);

export default getInvoiceApi;
